"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apophis = void 0;
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var ResourceType_1 = require("../../../ResourceType");
var SelectApophisCorpEffect_1 = require("../../../deferredActions/SelectApophisCorpEffect");
var CardRenderItem_1 = require("../../render/CardRenderItem");
var Size_1 = require("../../render/Size");
var Apophis = (function (_super) {
    __extends(Apophis, _super);
    function Apophis() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.APOPHIS,
            startingMegaCredits: 40,
            tags: [Tags_1.Tags.SPACE],
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            initialActionText: 'Draw a Space Event',
            metadata: {
                cardNumber: 'L422',
                description: 'You start with 40 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(40).nbsp.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.SPACE_EVENT).br;
                    b.titanium(3).asteroids(2);
                    b.corpBox('effect', function (ce) {
                        ce.text('When any player plays a space event, you gain 2 M€. When you play a space event, add 1 asteroid resource to this card OR remove 1 asteroid resource from this card and raise either temperature or Venus 1 step.', Size_1.Size.TINY, true);
                    });
                }),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    Apophis.prototype.initialAction = function (player) {
        player.drawCard(1, {
            include: function (card) { return card.cardType === CardType_1.CardType.EVENT && card.tags.includes(Tags_1.Tags.SPACE); },
        });
        return undefined;
    };
    Apophis.prototype.onCardPlayed = function (player, card) {
        this.effect(player, card);
    };
    Apophis.prototype.play = function (player) {
        player.titanium += 3;
        this.resourceCount = 2;
        return undefined;
    };
    Apophis.prototype.effect = function (activePlayer, card) {
        var gainPerSpaceEvent = 2;
        var apophisPlayer = activePlayer.game.getCardPlayer(this.name);
        if (card.cardType === CardType_1.CardType.EVENT && card.tags.includes(Tags_1.Tags.SPACE)) {
            apophisPlayer.megaCredits += gainPerSpaceEvent;
            if (activePlayer.id === apophisPlayer.id) {
                apophisPlayer.game.defer(new SelectApophisCorpEffect_1.SelectApophisCorpEffect(apophisPlayer));
            }
        }
        return undefined;
    };
    return Apophis;
}(Card_1.Card));
exports.Apophis = Apophis;
//# sourceMappingURL=Apophis.js.map